import { useMemo } from 'react';
import { scrollTo } from '../../../utils/lenis';
import './Highlight.css';

const items = ['Budget Friendly', 'Exceptional 24/7 Support', 'Problem Solving', 'User Friendly', 'Aesthetic Visualizer'];

export default function Main() {
    const checkIcon = useMemo(() => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    ), []);

    return (
        <div className='HighlightWrapper' id='home'>
            <div className="mainbody">
                <div className="particle-overlay">
                    {[...Array(10)].map((_, i) => (
                        <div
                            key={i}
                            className="particle-dot"
                            style={{
                                '--delay': `${(i * 1.3) % 8}s`,
                                '--duration': `${14 + (i * 2.1) % 12}s`,
                                '--tx': `${Math.cos(i * 36 * Math.PI / 180) * (40 + (i * 9) % 55)}vw`,
                                '--ty': `${Math.sin(i * 36 * Math.PI / 180) * (30 + (i * 6) % 40)}vh`,
                                '--opacity': `${0.3 + (i % 5) * 0.12}`,
                            }}
                        />
                    ))}
                </div>

                <div className="highlight-content">
                    <h1 className='HighlightHeading'>
                        Complex Workflows<br />Simplified
                    </h1>
                    <p className='HighlightParagraph'>
                        Custom digital infrastructure
                        for businesses with complex workflows, from enterprise applications to
                        scalable web platforms.
                    </p>

                    <div className='HighlightButtonSection'>
                        <button
                            className='secondarybutton'
                            onClick={() => scrollTo('#our-products', { offset: -80 })}
                        >
                            Explore Solutions
                        </button>
                    </div>
                </div>

                <div className='HighlightTickerSection'>
                    <div className='ticker-track'>
                        {[...items, ...items].map((item, i) => (
                            <div key={i} className='ticker-item'>
                                <span className='ticker-check'>{checkIcon}</span> {item}
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </div>
    );
}